import { getAllProcessNames } from '../../../transactions/transaction';
import isWaitlistProcess from '../utils/isWaitlistProcess';

export const BOOKING_TRANSACTION_TYPE = 'bookings';
export const WAITLIST_TRANSACTION_TYPE = 'waitlist';

export const getQueryConfig = () => {
  const allProcessNames = getAllProcessNames();

  const [waitlistProcess, otherProcesses] = allProcessNames.reduce(
    (acc, processName) => {
      if (isWaitlistProcess(processName)) {
        acc[0].push(processName);
      } else {
        acc[1].push(processName);
      }
      return acc;
    },
    [[], []]
  );
  return {
    [BOOKING_TRANSACTION_TYPE]: otherProcesses,
    [WAITLIST_TRANSACTION_TYPE]: waitlistProcess,
  };
};

export const QUERY_BY_ROLE = {
  [BOOKING_TRANSACTION_TYPE]: {
    orders: { meta_deletedByCustomer: false },
    sales: { meta_deletedByProvider: false },
  },
  [WAITLIST_TRANSACTION_TYPE]: {
    orders: { meta_deletedByCustomer: false, hasMessage: true },
    sales: { meta_deletedByProvider: false },
  },
};
